export default "__VITE_ASSET__DUg3vMJI__"